export const ELOQUA_CONNECT_PAGE_TITLE = 'Connect to Eloqua';
export const ELOQUA_CONNECT_PAGE_DESCRIPTION =
    'HG Insights wants to connect to your Eloqua account to:';
export const ELOQUA_ALREADY_CONNECT_PAGE_DESCRIPTION =
    'You are already authenticated with an Eloqua account:';
export const ELOQUA_CONNECT_NOTE =
    'Note: HG Insights does not use or retain this data in any way.';
